import kids from './kids';
import men from './men';
import women from './women';
import printBarcode from '@assets/bb-icons/print-barcode.ts';

export default {
    kids,
    men,
    women,
    'print-barcode': printBarcode,
};
